import { makeGetRequest, makePatchRequest } from 'request';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';


const AddDestinationPlantAndConsignee = (props: any) => {
    const { materialReadinessDocument, getMaterialReadinessDocuments} = props
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [selectedPackageId, setSelectedPackageId] = useState("")
    const [finalShippingAddresses, setFinalShippingAddresses] = useState<Record <string, any>>([])
    const [listOfPackages, setListOfPackages] = useState(materialReadinessDocument
        .packingLists
        .flatMap((record: any) => record.packages)
    )
    const [initialListOfPackages,] = useState(materialReadinessDocument
        .packingLists
        .flatMap((record: any) => record.packages)
    )
    const [areListsEqual, setAreListsEqual] = useState(true)

    // use useeffect to check if the intialListofpackages consignee and destination plant is the same as the listOfPackages consignee and destination plant.
    useEffect(() => {
        const areListsEqual = (list1: any, list2: any) => {
            return list1.every((item: any, index: any) => item.consignee === list2[index].consignee && item.destinationPlant === list2[index].destinationPlant);    
        }
        if(!areListsEqual(initialListOfPackages, listOfPackages)) setAreListsEqual(false)
            //eslint-disable-next-line
        },[listOfPackages]
    )
    
    const columnStyle = (alignment: any) => {
        return {
            padding: 0,
            backgroundColor: "transparent",
            width: "100%",
            verticalAlign: "top",
            textAlign: alignment
        }
    }
    const customColumnStyle = (modeOfTransportationChangeStatus: string) => {
    
        return {
            padding: "5px", 
            minHeight: "35px", 
            backgroundColor: "#F5F5F5",
            color: modeOfTransportationChangeStatus?.toLowerCase() === "approved" ? "#929292" : "black",
        }
    }

    const getSAPFinalShippingAddressMapper = () => {
        // setIsLoading(true)
        var request: Record<string, any> = {
            what: "getSAPFinalShippingAddressMapper",
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data
                setFinalShippingAddresses(res)
            })
            .catch((error:any) => 
                console.log(error.errorMessage)
            );    
        }

    const handleConsigneeAndDestinationPlantUpdate = (pckId: string) => {
        setSelectedPackageId(pckId)
        if(listOfPackages.find((record: any) => record.id === pckId)?.consignee && listOfPackages.find((record: any) => record.id === pckId)?.destinationPlant){
            var request: Record<string, any> = {
                what: "UpdateConsigneeAndDestinationPlantUpdate",
                data: {
                    packageId: pckId,
                    consignee: listOfPackages.find((record: any) => record.id === pckId)?.consignee,
                    destinationPlant: listOfPackages.find((record: any) => record.id === pckId)?.destinationPlant
                }
            };
            setIsSubmitting(true)
            makePatchRequest(request)
                .then((response: any) => {
                    setIsSubmitting(false)
                    toast.success(response.msg)
                    setSelectedPackageId("")                    
                    getMaterialReadinessDocuments("2")
                })
                .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});
        }else {
            toast.error("Please select the Consignee and Destination Plant to continue.")
        }
    }

    const handleChange = (event: any, pckId: string) => {        
        const { name, value } = event.target //get data form each input on change
        //handle listOfPackages change based on the paackage id
        setListOfPackages(listOfPackages.map((record: any) => record.id === pckId ? {...record, [name]: value} : record))
    }

    useEffect(() => {
        getSAPFinalShippingAddressMapper()
    }, [])

    return (
        <div style={{paddingTop: "12px"}}>
            {!areListsEqual && <div className="alert alert-info" style={{margin: "0 12px 12px 12px", width: "auto", padding:"12px"}}>
                <span className="material-symbols-outlined mr-2 f-16">info</span>
                <p style={{margin: 0}}>Some of the packages have not been updated with the selected consignee and destination plant. Kindly click the "Update" button against the packages.</p>
            </div>}
        
            <table className='template-form f-10' style={{tableLayout: 'fixed', width: '100%', borderCollapse: "separate" }}>
            <thead>
                <tr>
                <th className='text-center' style={{ width: '10%' }}>PACKAGE NUMBER</th>
                <th className='text-center' style={{ width: '10%' }}>DIMENSIONS (LxWxH)</th>
                {/* <th className='text-center' style={{ width: '10%' }}>CUBIC METER (M<sup>3</sup>)</th>
                <th className='text-center' style={{ width: '10%' }}>GROSS WEIGHT (KG)</th> */}
                <th className='text-center' style={{ width: '5%' }}>MATERIAL NUMBER</th>              
                <th className='text-center' style={{ width: '5%' }}>ITEM NUMBER</th>
                <th style={{ width: '20%' }}>MATERIAL DESCRIPTION</th>     
                {/* <th className='text-center' style={{ width: '10%' }}>SHIPMENT MODE</th>         */}
                {/* <th className='text-center' style={{ width: '10%' }}>HS CODE</th>
                <th style={{ width: '10%' }}>COUNTRY OF ORIGIN</th> */}
                {/* <th className='text-center' style={{ width: '5%' }}>QTY</th> */}
                <th className='text-center' style={{ width: '15%' }}>CONSIGNEE</th>
                <th className='text-center' style={{ width: '20%' }}>DESTINATION PLANT</th>
                {!materialReadinessDocument?.freightForwarderId && <th style={{ width: '7%' }}>ACTION</th>}
                </tr>
            </thead>
            <tbody>
                {
                listOfPackages?.map((pck: any, index: number) => {
                    return (
                        <tr className='plain'>
                        <td className='text-center'>Package {index + 1}</td>
                        <td className='text-center'>{pck.length} x {pck.width} x {pck.height}cm</td>
                        {/* <td className='text-center'>{pck.cubicMeter}</td>
                        <td className='text-center'>{pck.grossWeight}</td> */}
                        {/* Supplier Material Column */}
                        <td style={columnStyle("center")}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {pck.purchaseOrderItemSupplies
                                    .map((item: any, idx: number) => (
                                        <div key={idx} style={customColumnStyle(item?.modeOfTransportationChangeStatus)}>
                                            {item.purchaseOrderItem.materialNumber}
                                        </div>
                                    ))}
                            </div>
                        </td>
                        {/* Item Number Column */}
                        <td style={columnStyle("center")}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {pck.purchaseOrderItemSupplies
                                    .map((item: any, idx: number) => (
                                        <div key={idx} style={customColumnStyle(item?.modeOfTransportationChangeStatus)}>
                                            {item.purchaseOrderItem.purchaseOrderItemNumber}
                                        </div>
                                    ))}
                            </div>
                        </td>
                        {/* Material Desc Column */}
                        <td style={columnStyle("left")}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {pck.purchaseOrderItemSupplies
                                    .map((item: any, idx: number) => (
                                        <div key={idx} style={customColumnStyle(item?.modeOfTransportationChangeStatus)}>
                                            {item.purchaseOrderItem.materialDescription}
                                        </div>
                                    ))}
                            </div>
                        </td>
                        {/* Mode of Shipping */}
                        {/* <td style={columnStyle("center")}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {pck.purchaseOrderItemSupplies
                                    .map((item: any, idx: number) => (
                                        <div key={idx} style={customColumnStyle(item?.modeOfTransportationChangeStatus)}>
                                            {item?.modeOfTransportationChangeStatus?.toLowerCase() === "approved" ? "Air": "Sea"}
                                        </div>
                                    ))}
                            </div>
                        </td> */}
                        {/* HS Code Column */}
                        {/* <td style={columnStyle("center")}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {pck.purchaseOrderItemSupplies
                                    .map((item: any, idx: number) => (
                                        <div key={idx} style={customColumnStyle(item?.modeOfTransportationChangeStatus)}>
                                            {item.harmonisedSystemCode}
                                        </div>
                                    ))}
                            </div>
                        </td> */}
                        {/* Country of Origin Column */}
                        {/* <td style={columnStyle("left")}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {pck.purchaseOrderItemSupplies
                                    .map((item: any, idx: number) => (
                                        <div key={idx} style={customColumnStyle(item?.modeOfTransportationChangeStatus)}>
                                            {item.countryOfOrigin}
                                        </div>
                                    ))}
                            </div>
                        </td> */}
                        {/* Quantity Column */}
                        {/* <td style={columnStyle("center")}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {pck.purchaseOrderItemSupplies
                                    .map((item: any, idx: number) => (
                                        <div key={idx} style={customColumnStyle(item?.modeOfTransportationChangeStatus)}>
                                            {item.quantity}
                                        </div>
                                    ))}
                            </div>
                        </td> */}
                        {materialReadinessDocument?.freightForwarderId && 
                        <>
                            <td>{pck.consignee}</td>
                            <td>{pck.destinationPlant}</td>
                        </>}
                        
                        {(!materialReadinessDocument?.freightForwarderId 
                            // || (pck.consignee === null || pck.destinationPlant === null)
                        ) &&
                        <>
                            <td style={{textAlign: "center"}}>
                                <select 
                                    name='consignee' 
                                    value={pck.consignee} 
                                    style={{border: pck.consignee !== initialListOfPackages?.find((item: any) => item.id === pck.id)?.consignee ? "1px solid red" : ""}}
                                    onChange={(event) => handleChange(event, pck.id)}>
                                        <option value="" key="0">Select Consignee</option>
                                        <option value="TEPNG" key="1">TEPNG</option>
                                        <option value="TUPNI" key="2">TUPNI</option>
                                </select>
                            </td>
                            <td style={{textAlign: "center"}}>
                                <select 
                                    name='destinationPlant' 
                                    value={pck.destinationPlant} 
                                    style={{border: pck.destinationPlant !== initialListOfPackages?.find((item: any) => item.id === pck.id)?.destinationPlant ? "1px solid red" : ""}}
                                    onChange={(event) => handleChange(event, pck.id)}>
                                        <option value="" key="0">Select Destination Plant/Site</option>
                                        {
                                            Array.from(new Set(finalShippingAddresses?.map((item: any) => item.destinationPlantOrSiteOrProject)))
                                            ?.sort((a: any, b: any) => a.localeCompare(b))
                                            ?.map((item: any, index: number) => (
                                                <option value={item} key={index}>{item}</option>
                                            ))
                                        }
                                </select>
                            </td>
                            <td>
                                <button 
                                disabled={(isSubmitting && selectedPackageId === pck.id)
                                    //  || !pck.consignee || !pck.destinationPlant === null
                                    }
                                    className='custom-button orange'
                                    onClick={() => handleConsigneeAndDestinationPlantUpdate(pck.id)}>{isSubmitting && selectedPackageId === pck.id ? "Updating..." : "Update"}</button>
                            </td>
                        </>}                      
                        </tr> 
                    )
                })
                }
                {/* <tr>
                <td colSpan={6}></td>
                <td className='fw-600'>Total PCS</td>
                <td className='text-center yellow'>{listOfPackages
                                    ?.map((item: any) => item.purchaseOrderItemSupplies)
                                    ?.flat()
                                    ?.map((item: any) => item.quantity)
                                    .reduce((acc: number, item: any) => acc + Number(item), 0)}</td>
                
                </tr>
                <tr>
                <td colSpan={9} style={{padding: "2px 0", backgroundColor: "white"}}></td>
                </tr> */}

                {/* <tr>
                <td colSpan={2}>Country of Supply</td>
                <td colSpan={9}>{data?.countryOfSupply}</td>
                </tr>
                <tr>
                <td colSpan={2}>Destination</td>
                <td colSpan={9}>{data?.destination}</td>
                </tr>        */}
            </tbody>
            <ToastContainer />
            </table>  
        </div>      
    )
}

export default AddDestinationPlantAndConsignee